"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequiredTruckloadLineItemGs1BolInfo = void 0;
exports.RequiredTruckloadLineItemGs1BolInfo = {
    Class: 'NMFC_CLASS',
    Number: 'NMFC_NUMBER'
};
//# sourceMappingURL=required-truckload-line-item-gs1-bol-info.js.map